// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-mode {
  border: 2px solid transparent;
  width: 100%;
  padding: 0;
  cursor: pointer;
  border-radius: 0.5rem;
  height: auto;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--black0);
}
.invoice-mode img {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  object-fit: contain;
}
.invoice-mode.active {
  border: 2px solid var(--purple6);
}
.invoice-mode-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  justify-content: space-between;
}
.invoice-mode-title {
  margin-bottom: 1.5rem;
  width: 100%;
}
.invoice-mode-block {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: calc(50% - 1rem);
}
@media (max-width: 768px) {
  .invoice-mode-block {
    width: 100%;
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/setup/invoice.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AACJ;AAEE;EACE,gCAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAIE;EACE,qBAAA;EACA,WAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AAHJ;AAKI;EANF;IAOI,WAAA;IACA,mBAAA;EAFJ;AACF","sourcesContent":[".invoice-mode {\n  border: 2px solid transparent;\n  width: 100%;\n  padding: 0;\n  cursor: pointer;\n  border-radius: .5rem;\n  height: auto;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: var(--black0);\n\n  img {\n    width: 100%;\n    height: 100%;\n    border-radius: 0.5rem;\n    object-fit: contain;\n  }\n\n  &.active {\n    border: 2px solid var(--purple6);\n  }\n\n  &-container {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 2rem;\n    justify-content: space-between;\n  }\n\n  &-title {\n    margin-bottom: 1.5rem;\n    width: 100%;\n  }\n\n  &-block {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: calc(50% - 1rem);\n\n    @media (max-width: 768px) {\n      width: 100%;\n      margin-bottom: 1rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
